import "../../App.css"
import HeroSection from "../HeroSection/HeroSection"
import ProjectsSection from "../ProjectsSection/ProjectsSection";

function Home() {
    return (
        <div className="page-container">
            <HeroSection />
            <ProjectsSection id="projectsSection"/>
        </div>
    );
}

export default Home;